module.exports = __webpack_public_path__ + "img/blk.87385553.svg";